import { NgModule } from '@angular/core';

import { StatementsContainerComponent } from './statements.container';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StatementEffects } from './statements.effects';
import { SharedModule } from '../../shared/shared.module';
import { MobileCardComponent } from './mobile-card/mobile-card.component';
import { FieldModule } from 'atlas-field';
import { CardModule } from 'atlas-card';
import { TableModule } from 'atlas-table';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { PaginationModule } from 'atlas-pagination';
import { TooltipModule } from 'atlas-tooltip';
import { CheckboxModule } from 'atlas-checkbox';
import { ListModule } from 'atlas-list';
import { CdkModule, DateAdapter, NativeDateAdapter } from 'atlas-cdk';
import { DATE_FORMATS, DATE_LOCALE } from 'atlas-cdk';
import { LegacyModule } from 'atlas-legacy';
import { MenuModule } from 'atlas-menu';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  StatementsContainerComponent,
  MobileCardComponent
];
// const MY_DATE_FORMAT = {
//   parse: {
//     dateInput: 'dd/M/yyyy', // How dates should be parsed from user input
//   },
//   display: {
//     dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },  // Format for date input fields
//     dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' }, // Format for accessibility (screen readers)
//     monthYearLabel: { year: 'numeric', month: 'short' }, // Format for concise month-year displays
//     monthYearA11yLabel: { year: 'numeric', month: 'long' }, // Accessibility format for month-year displays
//   },
// };


// const MY_DATE_FORMAT = {
//   parse: {
//     dateInput: 'dd/M/yyyy',
//   },
//   // display: {
//   //   dateInput: { year: 'numeric', month: 'long', day: '2-digit' },
//   //   dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
//   //   monthYearA11yLabel: { year: 'numeric', month: 'long' },
//   //   monthYearLabel: { year: 'numeric', month: 'long' },
//   // }
//   display: {
//     ateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
//     dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
//     monthYearA11yLabel: { year: 'numeric', month: 'long' },
//     monthYearLabel: { year: 'numeric', month: 'short' },
//   },
// };



const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'dd LLLL yyyy', // 11 July 2025
  },
  display: {
    dateInput: { year: 'numeric', month: 'short', day: 'numeric' }, // e.g. Jul 11, 2025 with 'en-GB'
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
@NgModule({
  declarations: COMPONENTS,
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    FieldModule,
    CardModule,
    TableModule,
    IconModule,
    ButtonModule,
    PaginationModule,
    TooltipModule,
    CheckboxModule,
    ListModule,
    MenuModule,
    LinkModule,
    CdkModule,
    LegacyModule,
    EffectsModule.forFeature([StatementEffects])
  ],
  exports: COMPONENTS,
  providers: [
    { provide: DateAdapter, useClass: NativeDateAdapter },

    { provide: DATE_LOCALE, useValue: 'en-GB' },
    { provide: DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],
  bootstrap: [],
})
export class StatementsModule {
}
